import bufferedRows from "@baserow/modules/database/store/view/bufferedRows";
import { getRowMetadata } from "@baserow/modules/database/utils/row";

import CalendarService from "@peninsula/services/calendar";

function populateRow(row, metadata = {}) {
  row._ = { metadata: getRowMetadata(row, metadata) };
  return row;
}

const buffered = bufferedRows({
  service: CalendarService,
  customPopulateRow: populateRow,
});

export const state = () => ({ ...buffered.state() });
export const mutations = { ...buffered.mutations };
export const getters = { ...buffered.getters };
export const actions = {
  ...buffered.actions,

  async fetchInitial(
    { dispatch, getters },
    { viewId, fields, adhocFiltering, adhocSorting },
  ) {
    const data = await dispatch("fetchInitialRows", {
      viewId,
      fields,
      initialRowArguments: { includeFieldOptions: true },
      adhocFiltering,
      adhocSorting,
    });
    if (!data) return;

    await dispatch("forceUpdateAllFieldOptions", data.field_options);

    // ponytail: load the small private CRM in pages; add a date-range API only if
    // measured row volume makes this too slow.
    const pageSize = getters.getRequestSize;
    for (
      let offset = data.results.length;
      offset < data.count;
      offset += pageSize
    ) {
      await dispatch("fetchMissingRowsInNewRange", {
        startIndex: offset,
        endIndex: Math.min(offset + pageSize - 1, data.count - 1),
      });
    }
  },

  async refresh(
    { dispatch, getters },
    { fields, adhocFiltering, adhocSorting },
  ) {
    await dispatch("fetchInitial", {
      viewId: getters.getViewId,
      fields,
      adhocFiltering,
      adhocSorting,
    });
  },
};

export default { namespaced: true, state, getters, actions, mutations };
